import React from 'react'
import classnames from 'classnames'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Header from '../widgets/common/Header'
import Footer from '../widgets/common/Footer'
import Filter from '../widgets/Claims/Filter'
import ClaimSummary from '../widgets/Claims/ClaimSummary'
import ClaimLines from '../widgets/Claims/ClaimLines'
import ClaimLinesDetails from '../components/ClaimLineDetails'
import RBButton from '../controls/RBButton'
import EmptyClaimsState from '../widgets/Claims/EmptyClaimsState'
import { localize } from '../util/Localizer'
import Loading from '../widgets/Loading'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { push } from 'connected-react-router'
import { fetchClaims, fetchClaimFilters, storeFilters, changePage, changeSize } from '../redux/actions/claimsActions'
import { withStyles } from '@material-ui/core/styles'
import PaginationStyles from '../styles/components/pagination'
import { Redirect } from 'react-router-dom'

class Claims extends React.Component {
  constructor () {
    super()
    this.changeNext = this.changeNext.bind(this)
    this.changePrev = this.changePrev.bind(this)
    this.changePage = this.changePage.bind(this)
    this.returnRedirect = this.returnRedirect.bind(this)
    this.state = {
    }
  }

  componentDidMount () {
    this.props.fetchClaimFilters(() => {
      this.props.fetchClaims(this.props.filterObj, this.props.pageNum, this.props.pageSize)
    })
  }

  componentWillUnmount () {
    this.props.storeFilters(this.props.defaultFilterObj)
  }

  changeNext () {
    this.changePage(this.props.pageNum + 1)
  }
  changePrev () {
    this.changePage(this.props.pageNum - 1)
  }
  changePage (number) {
    if (this.props.pageNum !== number) {
      this.props.changePage(number)
      this.props.fetchClaims(this.props.filterObj, number, this.props.pageSize)
    }
  }
  changePageSize = (size = 10) => {
    if (this.props.pageSize !== size) {
      this.props.changeSize(size)
      this.props.fetchClaims(this.props.filterObj, this.props.pageNum, size)
    }
  }

  renderPageSize () {
    const { classes = {} } = this.props

    return (
      <Col>
        <div className={classes.claimTitleBox}>
          <div className={classes.itemPerPage}>
            <p> {localize('pages.claims.items')}</p>
            <ul>
              <li onClick={() => { this.changePageSize(10) }} className={classnames(classes.pageButton, { active: this.props.pageSize === 10 })}>10</li>
              <li onClick={() => { this.changePageSize(20) }} className={classnames(classes.pageButton, { active: this.props.pageSize === 20 })}>20</li>
              <li onClick={() => { this.changePageSize(40) }} className={classnames(classes.pageButton, { active: this.props.pageSize === 40 })}>40</li>
              <li onClick={() => { this.changePageSize(80) }} className={classnames(classes.pageButton, { active: this.props.pageSize === 80 })}>80</li>
            </ul>
          </div>
          <h4 className='sectionHeading '>{localize('pages.claims.header')}</h4>
        </div>
      </Col>
    )
  }

  renderPagination () {
    const { classes = {} } = this.props
    const self = this
    let total = this.props.totalPages
    let currentPage = this.props.pageNum
    const buildPages = (pageNum, totalPages) => {
      let pages = Array.from({ length: totalPages }, (v, i) => ++i)

      if (totalPages > 9) {
        pages = pages.filter(page => {
          if (page < 3) { // first two
            return true
          } else if (page > totalPages - 2) { // Last two
            return true
          } else if (page >= pageNum - 2 && page <= pageNum + 2) { // padding when in the middle
            return true
          } else { return false }
        })
      }

      if (pages.length === 9 && pages[7] !== totalPages - 2 && pages[6] !== pages[7] - 1) { // Add the last ...
        pages.splice(7, 0, -1)
      }

      if (pages.length > 4 && pages[2] !== 3) { // Add the first ...
        pages.splice(2, 0, -1)
      } else if (pages.length >= 5 && pages.length < 9) {
        pages = pages.filter((page) => {
          if (page < 3) { // first two
            return true
          } else if (page > totalPages - 2) { // Last two
            return true
          } else if (page >= pageNum - 2 && page <= pageNum + 2) { // padding when in the middle
            return true
          } else { return false }
        })

        if (totalPages > currentPage + 3 && totalPages > 5) {
          pages.splice(pages.length - 2, 0, -1)
        } else if (currentPage > 3 && totalPages > 5) {
          pages.splice(2, 0, -1)
        } else if (totalPages < 6) {
          return pages
        }
      }

      return pages
    }

    let pagination = buildPages(currentPage, total, [[1, 2, 3, -1, 24, 25]])
    return (
      <Col className={classes.pagination}>
        <RBButton label={localize('pages.ariaLabel.previous')} variant='outlined' disabled={currentPage === 1} onClick={this.changePrev} />

        <div className={classes.paginationButtons}>
          <ul>
            {pagination.map(function (number, index) {
              const key = number === -1 ? 'dot' + index : number
              var output = number === -1 || number === -5
                ? <li
                  key={key}
                  id={number}
                  className={classes.pageButton}
                >...</li>
                : <li
                  key={key}
                  id={number}
                  onClick={() => { self.changePage(number) }}
                  className={classnames(classes.pageButton, { active: number === currentPage })}
                >{number}</li>

              return output
            })
            }
          </ul>
        </div>
        <RBButton label={localize('pages.ariaLabel.next')} variant='outlined' disabled={this.props.pageNum === total} onClick={this.changeNext} />
      </Col>
    )
  }

  renderResponsivePagination () {
    const { classes = {} } = this.props

    if (window.innerWidth < 1200) {
      return (
        <Col className={classnames(classes.responsivePagination, 'hidden-lg')} >
          <RBButton label={localize('pages.ariaLabel.previous')} variant='outlined' disabled={this.props.pageNum === 1} onClick={this.changePrev} />

          <div >
            <p>{this.props.pageNum} of {this.props.totalPages}</p>
          </div>
          <RBButton label={localize('pages.ariaLabel.next')} variant='outlined' disabled={this.props.pageNum === this.props.totalPages} onClick={this.changeNext} />
        </Col>
      )
    }
  }

  renderBody (isClaimLines, isClaimDetails) {
    if (this.props.isLoading) {
      return (
        <div className=''>
          <Loading message={localize('common.loadingContent')} />
        </div>
      )
    }

    if (isClaimLines) {
      return (<ClaimLines claimId={this.props.claimId} />)
    } else if (isClaimDetails) {
      return (<ClaimLinesDetails claimId={this.props.claimId} />)
    } else {
      if (this.props.claims && this.props.claims.length > 0) {
        return (
          <div>
            {this.renderPageSize()}
            <ClaimSummary claims={Array.from(this.props.claims || [])} push={this.props.push} downloadFile={this.downloadFile} />
            {this.renderPagination()}
            {this.renderResponsivePagination()}
          </div>
        )
      }

      if (this.filterBar && this.filterBar.selector.props.filters && this.props.claims && this.props.claims.length === 0) {
        const { benefits, members, status } = this.filterBar && this.filterBar.selector.props.filters
        if ((benefits || []).length > 0 || (members || []).length > 0 || (status || []).length > 0) {
          return (
            <EmptyClaimsState filteredEmptyState clearFilters={this.filterBar.wrappedInstance._wrappedInstance.clearFilters} />
          )
        }
      }
      return (
        <EmptyClaimsState />
      )
    }
  }

  returnRedirect () {
    const isBenefitsAvailable = this.props.memberSummary && this.props.memberSummary.isBenefitsAvailable
    // if member summary is loading, do nothing
    if ((isBenefitsAvailable !== undefined) && (this.props.memberSummaryIsLoading !== undefined)) {
      // if member summary is loaded and benefits are not availible, redirect to member
      if ((this.props.memberSummaryIsLoading === false) && (isBenefitsAvailable === false)) {
        return <Redirect to={'/Member/MemberSummary'} />
      }
    }
  }

  render () {
    const isClaimLines = window.location.pathname.toString().toLowerCase().indexOf('claimlines') > -1 && window.location.pathname.toString().toLowerCase().indexOf('details') === -1
    const isClaimDetails = window.location.pathname.toString().toLowerCase().indexOf('details') > -1
    let contentClassName = isClaimLines === true ? 'mainContentClaimLines' : 'mainContentClaims'
    if (isClaimDetails) {
      contentClassName = 'mainContentClaimLinesDetails'
    }

    const hasFilter = (isClaimLines === false && isClaimDetails === false)

    // generate the element to render
    const elem = (
      <div className={classnames('pageContent', 'pageContentClaims', { hasFilter })}>
        {this.returnRedirect()}
        <Header />
        {hasFilter ? <Filter innerRef={(comp) => { this.filterBar = comp }} /> : null}
        <section className={'mainContent ' + contentClassName}>
          <Grid fluid>
            <Row>
              <Col xs={12} lgOffset={1} lg={10}>
                {this.renderBody(isClaimLines, isClaimDetails)}
              </Col>
            </Row>
          </Grid>
          <Footer />
        </section>
      </div>
    )
    // needed to move loading out further to hide header so we can render it properly
    const loading = (
      <div className={classnames('loadingContainer')}>
        <Loading message={localize('common.loadingContent')} />
      </div>
    )

    return this.props.memberSummaryIsLoading ? loading : elem
  }

  downloadFile () {
    if (typeof (this.props.resource) === 'object' && !this.props.resource.hasErrorField) {
      const pdfFielBlob = this.b64toBlob(this.props.resource.fileContentField, 'application/pdf')
      const fileName = this.props.resource.fileNameField
      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
        window.navigator.msSaveOrOpenBlob(pdfFielBlob, fileName)
      } else {
        var downloadLink = document.createElement('a')
        downloadLink.download = fileName
        downloadLink.innerHTML = 'Download File'
        var URL = window.URL || window.webkitURL
        downloadLink.href = URL.createObjectURL(pdfFielBlob)
        if (!('webkitURL' in window)) {
          // Firefox requires the link to be added to the DOM before it can be clicked.
          downloadLink.href = URL.createObjectURL(pdfFielBlob)
          downloadLink.onclick = this.destroyDowloadLink
          downloadLink.style.display = 'none'
          document.body.appendChild(downloadLink)
        }

        downloadLink.click()
        URL.revokeObjectURL(downloadLink)
      }
    } else {
      this.genericModal.wrappedInstance.refs.wrappedInstance.handleOpen()
    }
  }

  destroyDowloadLink (event) {
    document.body.removeChild(event.target)
  }
}
function mapStateToProps (state, ownProps) {
  return {
    claims: state.ClaimsReducer.claims,
    error: state.ClaimsReducer.error,
    isLoading: state.ClaimsReducer.isLoading,
    pageNum: state.ClaimsReducer.pageNum || 1,
    totalPages: state.ClaimsReducer.totalPages,
    pageSize: state.ClaimsReducer.pageSize || 20,
    claimId: ownProps.match.params.claimId,
    filterObj: state.ClaimsReducer.filterObj,
    defaultFilterObj: state.ClaimsReducer.defaultFilterObj,
    filters: state.ClaimsReducer.filters,
    memberSummary: state.memberSummaryReducer.memberSummary,
    memberSummaryIsLoading: state.memberSummaryReducer.isLoading
  }
}

const ConnectedClaims = connect(mapStateToProps, { fetchClaims, fetchClaimFilters, storeFilters, changePage, changeSize, push })(injectIntl(Claims))

const styles = {
  ...PaginationStyles,
  loadingContainer: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}

export default withStyles(styles)(ConnectedClaims)



// WEBPACK FOOTER //
// ./src/components/Claims.js